(function () {
  let FORM_ID = 'verify-form';

  window.verifyFormRecaptchaCallback = function () {
    let form = document.getElementById(FORM_ID);
    if (!form) return;
    let block = form.querySelector('[data-verify-field="captcha"]');
    let err = block ? block.querySelector('.text-error') : null;
    if (err) err.textContent = '';
  };

  function run() {
    let form = document.getElementById(FORM_ID);
    if (!form) return;

    function getVerifySubmitUrl() {
      if (typeof window.getAPIUrl !== 'function') return '';
      let baseUrl = window.getAPIUrl('baseUrl');
      if (!baseUrl) return '';
      let partEndpoint = 'part';
      return baseUrl.charAt(baseUrl.length - 1) === '/' ? baseUrl + partEndpoint : baseUrl + '/' + partEndpoint;
    }

    function getVerifycodeRedirectUrl(status, message) {
      let path = '/pages/verifycode';
      let params = new URLSearchParams({ status: status });
      if (message) params.set('message', message);
      return window.location.origin + path + '?' + params.toString();
    }

    function showError(field, message) {
      let block = form.querySelector('[data-verify-field="' + field + '"]');
      let err = block ? block.querySelector('.text-error') : null;
      if (err) err.textContent = message || '';
    }

    function clearErrors() {
      form.querySelectorAll('.text-error').forEach(function (el) { el.textContent = ''; });
    }

    let MIN_ORDER_NUMBER_LENGTH = 16;
    let MAX_ORDER_NUMBER_LENGTH = 21;
    let MIN_LENGTH_MESSAGE = 'Please enter valid 16 digit spare serial number';
    let MAX_LENGTH_MESSAGE = 'Spare serial number must be at most 21 characters.';

    function validate() {
      clearErrors();
      let valid = true;
      let orderInput = document.getElementById('verify-order-number');
      let orderVal = (orderInput && orderInput.value) ? orderInput.value.trim() : '';
      if (!orderVal) {
        showError('order_number', 'Spare serial number is required.');
        valid = false;
      } else if (orderVal.length < MIN_ORDER_NUMBER_LENGTH) {
        showError('order_number', MIN_LENGTH_MESSAGE);
        valid = false;
      } else if (orderVal.length > MAX_ORDER_NUMBER_LENGTH) {
        showError('order_number', MAX_LENGTH_MESSAGE);
        valid = false;
      }
      let recaptchaResponse = form.querySelector('textarea[name="g-recaptcha-response"]');
      let captchaVal = recaptchaResponse ? recaptchaResponse.value : '';
      if (!captchaVal) {
        showError('captcha', 'Please complete the captcha.');
        valid = false;
      }
      return valid;
    }

    function setLoading(loading) {
      let btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = loading;
        btn.classList.toggle('loading', loading);
      }
    }

    function runFieldValidation(e) {
      let target = e.target;
      if (!target || !target.matches('input, select, textarea')) return;
      let block = target.closest('.form-block');
      if (!block || !form.contains(block)) return;
      let errEl = block.querySelector('.text-error');
      if (!errEl) return;
      if (block.getAttribute('data-verify-field') === 'order_number' && target.id === 'verify-order-number') {
        let val = (target.value || '').trim();
        if (!val) {
          errEl.textContent = 'Spare serial number is required.';
        } else if (val.length < MIN_ORDER_NUMBER_LENGTH) {
          errEl.textContent = MIN_LENGTH_MESSAGE;
        } else if (val.length > MAX_ORDER_NUMBER_LENGTH) {
          errEl.textContent = MAX_LENGTH_MESSAGE;
        } else {
          errEl.textContent = '';
        }
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!validate()) {
        let firstError = form.querySelector('.text-error');
        if (firstError && firstError.textContent.trim()) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      let baseUrl = getVerifySubmitUrl();
      if (!baseUrl) {
        showError('order_number', 'API is not configured.');
        return;
      }

      let orderInput = document.getElementById('verify-order-number');
      let recaptchaResponse = form.querySelector('textarea[name="g-recaptcha-response"]');
      let code = orderInput ? orderInput.value.trim() : '';
      let urlParams = new URLSearchParams(window.location.search);
      let userID = urlParams.get('userID') || 'test';
      let system = urlParams.get('system') || 'web';
      let captchaToken = recaptchaResponse ? recaptchaResponse.value : '';
      let params = new URLSearchParams({
        system: system,
        userID: userID,
        code: code,
        //'g-recaptcha-response': captchaToken
      });
      let url = baseUrl + (baseUrl.indexOf('?') !== -1 ? '&' : '?') + params.toString();
      let apiKey = (typeof window.getAPIUrl === 'function' && window.getAPIUrl('key')) || '';

      setLoading(true);
      fetch(url, {
        method: 'GET',
        headers: {
          'x-api-key': apiKey
        }
      })
        .then(function (res) {
          return res.text().then(function (text) {
            let isSuccess = false;
            let errorMessage = text || 'Request failed';
            try {
              let data = JSON.parse(text);
              let result = data && data.result;
              let product = result && result.product;
              if (res.ok && result && product != null) {
                isSuccess = true;
              } else {
                isSuccess = false;
                errorMessage = (result && result.message) || (data && data.message) || (data && data.error) || text || 'Request failed';
              }
            } catch (e) {
              isSuccess = false;
              errorMessage = text || 'Request failed';
            }
            if (isSuccess) {
              clearErrors();
              form.reset();
              if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) grecaptcha.reset();
              window.location.href = getVerifycodeRedirectUrl('success');
            } else {
              window.location.href = getVerifycodeRedirectUrl('error', errorMessage);
            }
          });
        })
        .catch(function (err) {
          window.location.href = getVerifycodeRedirectUrl('error', err.message || 'Something went wrong. Please try again.');
        })
        .finally(function () {
          setLoading(false);
        });
    });

    form.addEventListener('input', runFieldValidation);
    form.addEventListener('change', runFieldValidation);
    form.addEventListener('blur', runFieldValidation, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } 
  else {
    run();
  }
})();
